import { render, staticRenderFns } from "./Bga2InfoCard.vue?vue&type=template&id=f4a85cea&scoped=true"
import script from "./Bga2InfoCard.vue?vue&type=script&lang=js"
export * from "./Bga2InfoCard.vue?vue&type=script&lang=js"
import style0 from "./Bga2InfoCard.vue?vue&type=style&index=0&id=f4a85cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a85cea",
  null
  
)

export default component.exports